/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DurationChoiceResource } from './';
import {
    DurationChoiceResourceFromJSON,
    DurationChoiceResourceFromJSONTyped,
    DurationChoiceResourceToJSON,
} from './';
import type { ProjectType } from './';
import {
    ProjectTypeFromJSON,
    ProjectTypeFromJSONTyped,
    ProjectTypeToJSON,
} from './';
import type { WeeklyAvailability } from './';
import {
    WeeklyAvailabilityFromJSON,
    WeeklyAvailabilityFromJSONTyped,
    WeeklyAvailabilityToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDetailsCreationRequest
 */
export interface ProjectDetailsCreationRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectDetailsCreationRequest
     */
    budget?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailsCreationRequest
     */
    currencyCode?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectDetailsCreationRequest
     */
    dailyFreelancerRate?: number;
    /**
     * 
     * @type {DurationChoiceResource}
     * @memberof ProjectDetailsCreationRequest
     */
    durationChoice?: DurationChoiceResource;
    /**
     * 
     * @type {ProjectType}
     * @memberof ProjectDetailsCreationRequest
     */
    projectType?: ProjectType;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDetailsCreationRequest
     */
    startDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailsCreationRequest
     */
    subject: string;
    /**
     * 
     * @type {WeeklyAvailability}
     * @memberof ProjectDetailsCreationRequest
     */
    freelancerWeeklyAvailability?: WeeklyAvailability;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailsCreationRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the ProjectDetailsCreationRequest interface.
 */
export function instanceOfProjectDetailsCreationRequest(value: object): value is ProjectDetailsCreationRequest {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    return true;
}

export function ProjectDetailsCreationRequestFromJSON(json: any): ProjectDetailsCreationRequest {
    return ProjectDetailsCreationRequestFromJSONTyped(json, false);
}

export function ProjectDetailsCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDetailsCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'budget': json['budget'] == null ? undefined : json['budget'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'dailyFreelancerRate': json['dailyFreelancerRate'] == null ? undefined : json['dailyFreelancerRate'],
        'durationChoice': json['durationChoice'] == null ? undefined : DurationChoiceResourceFromJSON(json['durationChoice']),
        'projectType': json['projectType'] == null ? undefined : ProjectTypeFromJSON(json['projectType']),
        'startDate': (new Date(json['startDate'])),
        'subject': json['subject'],
        'freelancerWeeklyAvailability': json['freelancerWeeklyAvailability'] == null ? undefined : WeeklyAvailabilityFromJSON(json['freelancerWeeklyAvailability']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ProjectDetailsCreationRequestToJSON(value?: ProjectDetailsCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'budget': value['budget'],
        'currencyCode': value['currencyCode'],
        'dailyFreelancerRate': value['dailyFreelancerRate'],
        'durationChoice': DurationChoiceResourceToJSON(value['durationChoice']),
        'projectType': ProjectTypeToJSON(value['projectType']),
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'subject': value['subject'],
        'freelancerWeeklyAvailability': WeeklyAvailabilityToJSON(value['freelancerWeeklyAvailability']),
        'description': value['description'],
    };
}

